import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-accent text-weight-bold" }, "No estoy seguro"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-weight-bold" }, "Estoy seguro")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_slider = _resolveComponent("q-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_slider, _mergeProps(_ctx.$attrs, {
      class: "q-mt-lg",
      label: "",
      "label-always": ""
    }), null, 16)
  ]))
}